<style>
  .apigroups-foot-btn{
    text-align: center;
  }
</style>
<template>
  <el-card v-loading="loading">
    <div slot='header'>
      <el-button type="primary" @click="backtohome">返回</el-button>
      <template v-if="opertionType !== 'add'">
        <el-button
          type="primary"
          @click="editAPI"
          :disabled="opertionType === 'edit'">编辑</el-button>
        <el-button
          type="danger"
          @click="delAPI"
          :disabled="opertionType === 'edit'">删除</el-button>
      </template>
    </div>
    <el-form class="apigroups-body" :rules="rules" ref="APIform" :model="APIform" label-width="90px" :class="{detailsform:opertionType === 'detail'}">
      <el-row>
        <el-col :xs="24" :sm="24" :md="15" :lg="13">
          <el-form-item label='接口组'>
            <span>{{detailData.GroupNO}}.{{detailData.GroupName}}</span>
          </el-form-item>
          <el-form-item label="服务ID" prop="ServerID">
            <span v-if="opertionType === 'detail' || opertionType === 'edit'">{{APIform.ServerID}}</span>
            <el-input v-model="APIform.ServerID" size="small" placeholder="服务ID" :maxlength = 60 v-else></el-input>
          </el-form-item>
          <el-form-item label='服务描述' prop="AServerName">
            <span v-if="opertionType === 'detail'">{{APIform.AServerName}}</span>
            <el-input v-model="APIform.AServerName" size="small" :maxlength = 30 placeholder="服务描述" v-else></el-input>
          </el-form-item >
          <el-form-item label='服务类型' prop="ServerType">
            <span>{{APIform.ServerTypeID}}.{{APIform.ServerType}}</span>
          </el-form-item>
          <el-form-item label='接口名称' prop="InterfaceName">
            <span v-if="opertionType === 'detail'">{{APIform.InterfaceName}}</span>
            <el-input v-model="APIform.InterfaceName" size="small" :maxlength = 40 placeholder="接口名称" v-else></el-input>
          </el-form-item>
          <el-form-item label='接口状态' prop="Tag1">
            <el-radio-group v-model="APIform.Tag1" :disabled="opertionType === 'detail'">
              <el-radio  :label = 0>正常</el-radio>
              <el-radio  :label = 1>禁用</el-radio>
              <el-radio  :label = 2>维护中</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label='接口描述' prop="Summary">
            <span v-if="opertionType === 'detail'">{{APIform.Summary}}</span>
            <el-input
              type="textarea"
              :rows="4"
              placeholder="接口描述"
              v-else
              :maxlength = 1000
              v-model="APIform.Summary">
            </el-input>
          </el-form-item>
          <div class="apigroups-foot-btn">
            <el-button type="primary" v-if="opertionType !== 'detail'" @click="saveAPI">保存</el-button>
            <el-button type="primary" v-if="opertionType === 'edit'" @click="cancelEdit">取消</el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>

  </el-card>
</template>
<script>
  import util from '../../../util'
  import {DataObjectUpdate, bizQueryBatchExecute} from '../../../vuex/actions'
  import {sessionUser} from '../../../vuex/getters'
	export default {
	  props: ['opertion', 'detaildata', 'apitype'],
    vuex: {
      getters: {
        sessionUser
      },
      actions: {
        DataObjectUpdate,
        bizQueryBatchExecute
      }
    },
	  data(){
	    return{
        loading: false,
        GroupData: '',
        detailData: this.detaildata,
	      opertionType: this.opertion,
        APIform: {
          InterfaceName: '',
          AServerName: '',
          Summary: '',
          ServerTypeID: {
            StdQuery: '1',
            DataObject: '2',
            Business: '3',
          }[this.apitype],
          ServerType: this.apitype,
          ServerID: '',
          Tag1: 0,
          UpdateFlag: 'I'
        },
        rules: {
          ServerID: [
            { required: true, message: '请输入服务ID', trigger: 'blur' },
          ],
          AServerName: [
            { required: true, message: '请输入服务描述', trigger: 'blur' }
          ],
          ServerType: [
            { required: true, message: '请输入服务类型', trigger: 'blur' },
          ],
//          Tag1: [
//            { required: true, message: '请输入接口状态', trigger: 'blur' },
//          ],
          InterfaceName: [
            { required: true, message: '请输入接口名称', trigger: 'blur' },
          ],
        }
      }
    },
    mounted () {
	    this.queryDataObject()
	    if(this.opertionType === 'detail'){
	      this.loadParentData()
      }
    },
    methods:{
      queryDataObject () {
        let params = {
          objectName: 'OAuthGroup',
          GroupNO: this.detailData.GroupNO,
          PaperNO: '',
        }
        this.DataObjectUpdate(params, (res) => {
          if(res.isValid && res.data.isValid){
            this.GroupData = res.data.dataList.dataList_0[0]
          }
        })
      },
      editAPI () {
        this.opertionType = 'edit'
        this.APIform.UpdateFlag = 'U'
      },
      delAPI () {
        this.APIform.UpdateFlag = 'D'
        let params = {
          dataList_0: [{
            //请求必填参数
            BusinessID: 'OAuthGroupModify',
            OperName: this.sessionUser.userName,
            Operator: this.sessionUser.userId,
            LastUpdateTime: this.GroupData.LastUpdateTime,
            Old_LastUpdateTime: this.GroupData.LastUpdateTime,
            ModuleID: this.$route.params.moduleID || '299303',
            ActionNO: 'OAuthGroupModify',
            PaperNO: '',
            //输入参数
            GroupNO:this.GroupData.GroupNO,
            GroupName:this.GroupData.GroupName,
            Memo:this.GroupData.Memo,
          }],
          dataList_1: [{...this.APIform}]
        }
        this.$confirm(`确认要删除当前接口服务吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true
          this.bizQueryBatchExecute(params, (res) => {
            this.loading = false
            if(res.isValid && res.data.isValid){
              util.success(this, `接口${params.dataList_1[0].InterfaceName}删除成功`)
              this.$emit('goback')
            }
          })
        }).catch(() => {
          console.log('cancel')
        })
      },
      cancelEdit () {
        this.$confirm(`取消后编辑的信息将丢失，确认取消？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.opertionType = 'detail'
          this.loadParentData()
        }).catch(() => {
          console.log('cancel')
        })
      },
      loadParentData () {
        this.APIform = util.deepCopy(this.detailData, {})
      },
      backtohome(){
        if(this.opertionType === 'detail') return this.$emit('goback')
        this.$confirm(`返回后编辑的信息将丢失，确认返回？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$emit('goback')
        }).catch(() => {
          console.log('cancel')
        })
      },
      saveAPI () {
        let msg
        if(this.opertionType === 'edit'){
          msg = '修改'
        }else{
          msg = '新增'
        }
        if(this.validate()){
          let params = {
            dataList_0: [{
              //请求必填参数
              BusinessID: 'OAuthGroupModify',
              OperName: this.sessionUser.userName,
              Operator: this.sessionUser.userId,
              LastUpdateTime: this.GroupData.LastUpdateTime,
              Old_LastUpdateTime: this.GroupData.LastUpdateTime,
              ModuleID: this.$route.params.moduleID || '299303',
              ActionNO: 'OAuthGroupModify',
              PaperNO: '',
              //输入参数
              GroupNO:this.GroupData.GroupNO,
              GroupName:this.GroupData.GroupName,
              Memo:this.GroupData.Memo,
            }],
            dataList_1: [{...this.APIform}]
          }
          this.loading = true
          this.bizQueryBatchExecute(params, (res) => {
            this.loading = false
            if(res.isValid && res.data.isValid){
              this.queryDataObject()
              this.detailData = util.deepCopy(this.APIform, this.detailData)
              this.opertionType = "detail"
              util.success(this, `接口${params.dataList_1[0].InterfaceName}${msg}成功`)
            }else{

            }
          })
        }
      },
      validate () {
        let isValidate
        this.$refs['APIform'].validate((valid) => {
          if (valid) {
            isValidate = true
          } else {
            console.log('error submit!!');
            isValidate = false
            return false;
          }
        })
        return isValidate
      },
    }
  }
</script>




// WEBPACK FOOTER //
// apiServerDefinedAdd.vue?2e2e8e26